import { cn } from '@/app/utils/cn'
import { PlusCircle } from 'lucide-react'
import {
  HtmlHTMLAttributes,
  InputHTMLAttributes,
  ReactNode,
  useState,
} from 'react'

interface ImageUploadProps extends HtmlHTMLAttributes<HTMLDivElement> {
  inputProps?: InputHTMLAttributes<HTMLInputElement>
  onInputChange: (file: File) => void
  defaultImage?: string | null
  description?: ReactNode
  height?: number | string
  width?: number | string
  customPlaceholder?: ReactNode
}

const getFileUrl = (file: File) => {
  return URL.createObjectURL(file)
}

export const ImageUpload = ({
  inputProps,
  defaultImage = null,
  onInputChange,
  description,
  className,
  customPlaceholder,
  ...props
}: ImageUploadProps) => {
  const [image, setImage] = useState<string | null>(defaultImage)

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file) return
    setImage(getFileUrl(file))
    onInputChange(file)
  }

  return (
    <div
      className={cn(
        'flex cursor-pointer flex-col gap-4 border border-dashed border-gray-300 hover:border-gray-400 hover:bg-gray-100 active:border-gray-500 active:bg-gray-200',
        className,
      )}
      {...props}
    >
      {description}
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        style={{ display: 'none' }}
        id="file-upload"
        {...inputProps}
      />
      <label
        htmlFor="file-upload"
        className="w-full overflow-hidden rounded-lg"
      >
        {!image ? (
          customPlaceholder || (
            <div
              style={{
                minHeight: props.height,
                minWidth: props.width,
              }}
              className="flex h-full w-full cursor-pointer flex-col items-center justify-center gap-2 text-muted-foreground"
            >
              <PlusCircle size={32} />
              <span className="text-sm">Adicionar Imagem</span>
            </div>
          )
        ) : (
          <img
            className="w-full cursor-pointer object-cover"
            src={image}
            alt="upload"
            style={{
              flexShrink: 0,
              maxHeight: props.height,
              height: props.height,
              maxWidth: props.width,
              width: props.width,
              minWidth: props.width,
              minHeight: props.height,
            }}
          />
        )}
      </label>
    </div>
  )
}
